import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { IReminderHistory } from '../../store/ReminderStore';
import { setDate } from "../../../../../includes/util";

interface IProps {
  pageSizeChanged: any;
  pageNoChanged: any;
  items: any;
}

const ReminderHistoryListItem = (props: IProps) => {

  const { pageSizeChanged, pageNoChanged } = props;
  const items = props.items.Data;
  const paging = props.items.Paging;

  const onPage = (event: any) => {

    const { page, rows } = event;
    if (Number(paging.PageSize) !== rows) {
      pageSizeChanged(rows);
    }
    else if (Number(paging.PageSize) !== page + 1) {
      pageNoChanged(page + 1);
    }
  };

  const setNormalDataTable = () => {
    return (
      <DataTable
        rowHover
        style={{ position: "relative" }}
        //size="small"
        value={items}
        className="p-datatable-gridlines  p-datatable-gridlines-custom p-datatable-sm p-datatable-striped p-datatable-striped-custom"
        resizableColumns
        //columnResizeMode="fit"
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
        scrollable
        scrollHeight="calc(100vh - 390px)"
      >

        <Column field="ReminderId" header="Reminder Id" style={{ width: '120px' }} />
        <Column field="ReminderTypeName" header="Reminder Type Name" style={{ width: '250px' }} />
        <Column field="ReminderTypeCode" header="Reminder Type Code" style={{ width: '200px' }} />
        <Column field="CategoryName" header="Category" style={{ width: '200px' }} />
        <Column field="SubCategoryName" header="SubCategory" style={{ width: '200px' }} />

        <Column field="AssetPlate" header="Asset Plate" style={{ width: '120px' }} />
        <Column field="AssetCode" header="Asset Code" style={{ width: '120px' }} />
        <Column field="AssetTypeName" header="Type" style={{ width: '250px' }} />



        <Column field="DueAtTimestampUtc" header="DueAtTimestamp" body={(r: IReminderHistory) => r.DueAtTimestampUtc ? setDate(r.DueAtTimestampUtc) : ""} style={{ width: '250px' }} />
        <Column field="CompletedAtTimestampUtc" header="CompletedAtTimestamp" body={(r: IReminderHistory) => r.CompletedAtTimestampUtc ? setDate(r.CompletedAtTimestampUtc) : ""} style={{ width: '250px' }} />
        <Column field="DueAtOdometerKm" header="DueAtOdometer" body={(r: IReminderHistory) => r.DueAtOdometerKm ? Number(r.DueAtOdometerKm).toLocaleString() : ""} style={{ width: '250px', textAlign: 'right' }} />

        <Column field="CompletedAtOdometerKm" header="CompletedAtOdometerKm" body={(r: IReminderHistory) => r.CompletedAtOdometerKm ? Number(r.CompletedAtOdometerKm).toLocaleString() : ""} />
        <Column field="DueAtOperationalHours" header="DueAtOperationalHours" style={{ 'textAlign': 'right', width: '150px' }} />
        <Column field="CompletedAtOperationalHours" header="CompletedAtOperationalHours" style={{ 'textAlign': 'right', width: '250px' }} />
        <Column field="OverDueAtCompletion" header="OverDueAtCompletion" style={{ 'textAlign': 'center', width: '150px' }} />
        <Column field="OverDueOnDateAtCompletion" header="OverDueOnDateAtCompletion" style={{ 'textAlign': 'center', width: '150px' }} />
        <Column field="OverDueOnOdometerKmAtCompletion" header="OverDueOnOdometerKmAtCompletion" style={{ 'textAlign': 'center', width: '150px' }} />
        <Column field="OverDueOnOperationalHoursAtCompletion" header="OverDueOnOperationalHoursAtCompletion" style={{ 'textAlign': 'center', width: '150px' }} />
        <Column field="AssetMake" header="Make" style={{ width: '120px' }} />
        <Column field="AssetModel" header="Model" style={{ width: '120px' }} />
        <Column field="AssetYearOfManufacture" header="Year" style={{ width: '100px' }} />
        <Column field="AssetVin" header="Vin" style={{ width: '250px' }} />
      </DataTable>
    );
  };

  return (
    <>
      <div
        className="perfect-scrollbar"
        style={{ position: "relative", width: "100%", height: "100%" }}
      >
        {setNormalDataTable()}
      </div>

    </>
  );

};

export default ReminderHistoryListItem;